import React from "react";

const ExceptionDays = ({
  label = "Exception day",

  days = [
    {
        id: 1,
        name: "Monday",
        short_name: "Mon",
        day_number: 1,
    },
    {
        id: 2,
        name: "Tuesday",
        short_name: "Tue",
        day_number: 2,
    },
    {
        id: 3,
        name: "Wednesday",
        short_name: "Wed",
        day_number: 3,
    },
    {
        id: 4,
        name: "Thursday",
        short_name: "Thu",
        day_number: 4,
    },
    {
        id: 5,
        name: "Friday",
        short_name: "Fri",
        day_number: 5,
    },
    {
        id: 6,
        name: "Saturday",
        short_name: "Sat",
        day_number: 6,
    },
    {
        id: 7,
        name: "Sunday",
        short_name: "Sun",
        day_number: 7,
    }
  ],
  value = [],
  onChange,
}) => {
  
  const toggleDay = (dayValue) => {
    let updatedDays;
    if (value.includes(dayValue)) {
      updatedDays = value.filter((v) => v !== dayValue);
    } else {
      updatedDays = [...value, dayValue];
    }
    onChange(updatedDays);
  };

  return (
    <div className="text-white">
      {label && <label className="block mb-2">{label}</label>}
      <div className="flex gap-2 bg-gray-800 p-3 rounded">
        {days.map((day) => {
          const isSelected = value.includes(day.id);
          return (
            <button
              key={day.id}
              type="button"
              onClick={() => toggleDay(day.id)}
              className={`px-4 py-2 rounded transition-colors ${
                isSelected
                  ? "bg-yellow-500 text-black font-semibold"
                  : "bg-gray-700 text-gray-300 hover:bg-gray-600"
              }`}
            >
              {day.name}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ExceptionDays;
